var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileRemove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 2.6665C12.507 2.6665 9.66699 5.5065 9.66699 8.99984C9.66699 12.4265 12.347 15.1998 15.8403 15.3198C15.947 15.3065 16.0537 15.3065 16.1337 15.3198C16.1603 15.3198 16.1737 15.3198 16.2003 15.3198C16.2137 15.3198 16.2137 15.3198 16.227 15.3198C19.6403 15.1998 22.3203 12.4265 22.3337 8.99984C22.3337 5.5065 19.4937 2.6665 16.0003 2.6665Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7733 18.88C19.0533 16.4 12.9866 16.4 9.23995 18.88C7.54661 20 6.61328 21.5334 6.61328 23.1734C6.61328 24.8134 7.54661 26.3334 9.22661 27.4534C11.0933 28.7067 13.5466 29.3334 15.9999 29.3334C18.4533 29.3334 20.9066 28.7067 22.7733 27.4534C24.4533 26.32 25.3866 24.8 25.3866 23.1467C25.3733 21.52 24.4533 19.9867 22.7733 18.88Z",
    fill: "#FE9899"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.44 24.0934H13.5733C13.0667 24.0934 12.6533 23.6801 12.6533 23.1734C12.6533 22.6667 13.0667 22.2534 13.5733 22.2534H18.44C18.9467 22.2534 19.36 22.6667 19.36 23.1734C19.3467 23.6801 18.9467 24.0934 18.44 24.0934Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileRemove);
export default __webpack_public_path__ + "static/media/profileRemove.4e7804c1e61af2dece9b0dc4e6f50824.svg";
export { ForwardRef as ReactComponent };